import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Container as ListButtons } from '@propertypal/web-ui/src/buttons/ListButtons.style';
import styled from 'styled-components';

export const GalleryMapButtons = styled.div`
  position: relative;
  width: 100%;
  max-width: 1230px;
  margin: 0 auto;

  ${ListButtons} {
    position: absolute;
    top: -40px;
    right: 30px;

    @media (${laptopMediumMax}) {
      right: 15px;
    }

    @media (${mobileXXLargeMax}) {
      top: -30px;
    }
  }
`;

export default GalleryMapButtons;
